import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";
// Define the available sections as a union type for better typing
type Section =
  | "overview"
  | "matcher"
  | "assembler"
  | "interpreter"
  | "mpn-search";

const ToolboxPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] = useState<Section>("overview");

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/knowledge-hub/toolbox/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "overview" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("overview")}
          >
            Overview
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "matcher" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("matcher")}
          >
            Matcher
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "assembler" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("assembler")}
          >
            Assembler
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "interpreter"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("interpreter")}
          >
            Intepreter
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "mpn-search" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("mpn-search")}
          >
            MPN Search
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "overview" && (
          <DocumentationViewer filePath={markdownPaths.KHToolboxOverviewURL} />
        )}

        {selectedSection === "matcher" && (
          <DocumentationViewer filePath={markdownPaths.KHToolboxMatcherURL} />
        )}
        {selectedSection === "assembler" && (
          <DocumentationViewer filePath={markdownPaths.KHToolboxAssemblerURL} />
        )}

        {selectedSection === "interpreter" && (
          <DocumentationViewer
            filePath={markdownPaths.KHToolboxInterpreterURL}
          />
        )}
        {selectedSection === "mpn-search" && (
          <DocumentationViewer filePath={markdownPaths.KHToolboxMpnSearchURL} />
        )}
      </div>
    </div>
  );
};

export default ToolboxPage;
